export enum TypeRequest {
    None= 'None',
    Switch = 'Switch',
    Voltura = 'Voltura',
    Attivazione = 'Attivazione',
    Subentro = 'Subentro',
    CambioPiano = 'CambioPiano',
    VolturaConAttivazione = 'VolturaConAttivazione'
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/typeRequest.enum.ts